import { useContext } from "react";

import { AnalyticsContext } from "../contexts/bots/AnalyticsContext";

const useAnalytics = () => useContext(AnalyticsContext);

export default useAnalytics;
